'use es6';

import ScrollWrapper from 'conversations-visitor-message-history/scrolling/ScrollWrapper';
import RecordPropType from 'conversations-prop-types/prop-types/RecordPropType';
import { getOffsetTimestamp, getOffsetOrdinal } from 'conversations-message-history/thread-history/operators/getters';
import { hasMessages } from 'conversations-message-history/thread-history/operators/hasMessages';
import PropTypes from 'prop-types';
import { createRef, PureComponent } from 'react';
import styled from 'styled-components';
import VizExLoadingSpinner from 'visitor-ui-component-library/loading/VizExLoadingSpinner';
import classNames from 'classnames';
import { STUBBED_THREAD_ID } from '../../threads/constants/stubbedThreadId';
import ThreadHistoryError from './ThreadHistoryError';
import ScrollToButton from './ScrollToButton';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const LoadingSpinnerWrapper = styled(VizExLoadingSpinner).withConfig({
  displayName: "ThreadHistoryFetcher__LoadingSpinnerWrapper",
  componentId: "mpap2q-0"
})(["height:0;margin-top:20px;"]);
const ScrollContainerWrapper = styled.div.withConfig({
  displayName: "ThreadHistoryFetcher__ScrollContainerWrapper",
  componentId: "mpap2q-1"
})(["display:flex;justify-content:flex-end;flex-direction:column;overflow-x:hidden;overflow-y:hidden;position:relative;flex:1;"]);
class ThreadHistoryFetcher extends PureComponent {
  constructor(props) {
    super(props);
    this.handleScrollFromBottom = () => {
      if (!this.state.mountScrollTo) {
        this.setState({
          mountScrollTo: true,
          showScrollTo: true
        });
      }
    };
    this.handleScrollToBottom = () => {
      if (this.state.mountScrollTo) {
        this.setState({
          mountScrollTo: false
        });
      }
    };
    this.handleAnimationEnd = () => {
      if (!this.state.mountScrollTo) {
        this.setState({
          showScrollTo: false
        });
      }
    };
    this.state = {
      mountScrollTo: false,
      showScrollTo: false
    };
    this.scrollWrapper = /*#__PURE__*/createRef();
    this.fetchHistory = this.fetchHistory.bind(this);
    this.scrollToBottom = this.scrollToBottom.bind(this);
  }
  componentDidMount() {
    this.scrollToBottom();
    this.fetchHistory();
  }
  scrollToBottom() {
    if (this.scrollWrapper.current) {
      this.scrollWrapper.current.scrollTo(0, 0);
    }
  }
  scrollToBottomIfInThreshold() {
    if (this.scrollWrapper.current) {
      if (Math.abs(this.scrollWrapper.current.scrollTop) < 300) {
        this.scrollWrapper.current.scrollTo(0, 0);
      }
    }
  }
  componentDidUpdate(prevProps) {
    const {
      threadId,
      messageCount,
      shouldScrollToBottom,
      isOnFocus
    } = this.props;
    const {
      threadId: prevThreadId,
      messageCount: prevMessageCount,
      shouldScrollToBottom: prevshouldScrollToBottom,
      isOnFocus: prevIsOnFocus
    } = prevProps;
    const {
      current
    } = this.scrollWrapper;
    if (threadId !== prevThreadId) {
      this.fetchHistory();
      this.scrollToBottom();
      return;
    }
    if (!prevMessageCount) {
      this.scrollToBottom();
      return;
    }
    if (messageCount !== prevMessageCount) {
      this.scrollToBottomIfInThreshold();
    }
    if (shouldScrollToBottom !== prevshouldScrollToBottom && current) {
      this.scrollToBottomIfInThreshold();
    }
    if (isOnFocus !== prevIsOnFocus && current) {
      this.scrollToBottomIfInThreshold();
    }
  }
  fetchHistory() {
    const {
      fetchThreadHistory,
      threadId,
      threadHistory,
      sessionId
    } = this.props;
    if (threadId === STUBBED_THREAD_ID) {
      return;
    }
    fetchThreadHistory({
      offsetOrdinal: getOffsetOrdinal(threadHistory),
      offsetTimestamp: getOffsetTimestamp(threadHistory),
      threadId,
      sessionId
    });
  }
  render() {
    const {
      children,
      isLoadingHistory,
      loadingHistoryFailed,
      threadId,
      threadHistory,
      hideScrollToButton
    } = this.props;
    if (isLoadingHistory && !hasMessages(threadHistory)) {
      return /*#__PURE__*/_jsx(VizExLoadingSpinner, {
        grow: true
      });
    }
    if (loadingHistoryFailed && !hasMessages(threadHistory)) {
      return /*#__PURE__*/_jsx(ThreadHistoryError, {});
    }
    const className = classNames(this.props.className, 'messages-scroll-container-utv');
    return /*#__PURE__*/_jsxs(ScrollContainerWrapper, {
      children: [/*#__PURE__*/_jsx(ScrollWrapper, {
        className: className,
        ref: this.scrollWrapper,
        onScrollToTop: this.fetchHistory,
        stickToTop: isLoadingHistory && /*#__PURE__*/_jsx(LoadingSpinnerWrapper, {
          grow: true
        }),
        onScrollFromBottom: this.handleScrollFromBottom,
        onScrollToBottom: this.handleScrollToBottom,
        children: children
      }, threadId), this.state.showScrollTo && !hideScrollToButton && /*#__PURE__*/_jsx(ScrollToButton, {
        onClick: this.scrollToBottom,
        showScrollTo: this.state.mountScrollTo,
        onAnimationEnd: this.handleAnimationEnd,
        coloring: this.props.coloring
      })]
    });
  }
}
ThreadHistoryFetcher.displayName = 'ThreadHistoryFetcher';
ThreadHistoryFetcher.propTypes = {
  children: PropTypes.node.isRequired,
  className: PropTypes.string,
  coloring: PropTypes.object.isRequired,
  fetchThreadHistory: PropTypes.func.isRequired,
  hideScrollToButton: PropTypes.bool.isRequired,
  isLoadingHistory: PropTypes.bool,
  isOnFocus: PropTypes.bool.isRequired,
  loadingHistoryFailed: PropTypes.bool,
  messageCount: PropTypes.number.isRequired,
  sessionId: PropTypes.string.isRequired,
  shouldScrollToBottom: PropTypes.bool.isRequired,
  threadHistory: RecordPropType('ThreadHistory'),
  threadId: PropTypes.number.isRequired
};
export default ThreadHistoryFetcher;